import axios from '@/axios'
import Vue from 'vue'

const state = {
  operations: []
};
const actions = {
  fetchOperations({ commit }, config = {}) {
    return axios.get('operations', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_OPERATIONS', r.data.operations)
        } else {
          throw new Error("Operations forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_OPERATIONS(state, operations) {
    Vue.set(state, 'operations', operations)
  }
};

export default {
  state,
  actions,
  mutations
}
